import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-release",
  "use": "icon-release-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-release\"><defs><style type=\"text/css\"></style></defs><path d=\"M565.894737 847.575579v126.571789a40.421053 40.421053 0 0 1-80.842105 0V794.947368a40.421053 40.421053 0 0 1 20.237473-35.031579l-8.326737-5.01221L854.366316 143.925895 80.842105 541.076211l296.421053 133.173894v1.724632a40.421053 40.421053 0 0 1 0 76.261052v10.617264l-19.536842-8.784842a40.259368 40.259368 0 0 1-19.752421-8.892632l-289.818948-130.15579c-62.194526-27.944421-64.673684-114.957474-4.149894-145.81221L905.566316 30.073263c56.131368-28.591158 122.394947 14.821053 118.379789 77.608421l-51.469473 803.004632c-3.637895 56.266105-62.517895 91.459368-114.256843 68.230737L565.894737 847.575579z m17.704421-80.653474l302.403368 135.841684L934.642526 166.804211 583.599158 766.922105z\" p-id=\"8591\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/release.svg
// module id = sfIp
// module chunks = 58